module.exports = __webpack_public_path__ + "static/media/zym-bg.633dde11.jpg";